module.exports = __webpack_public_path__ + "static/img/img7.360501c7.png";